module.exports = __webpack_public_path__ + "img/BMBF.77f0a71e.png";